import {
    graphql
} from 'react-relay'


const query = graphql`
    query getAllContactMediumQuery ($pagination: PaginationInput, $sorts: [OrderInput!], $where: JSON) {
        getAllContactMedium (pagination: $pagination, sorts: $sorts, where: $where) {
            count,
            items {
                id
                name
                createdAt
                updatedAt
            }
      }
    }
  `

  export default query;